import { LitElement, html } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { consume } from '@lit/context'
import { customElement, property } from 'lit/decorators.js'
import { breakpointContext, displayModeContext } from './context.ts'
import { TW, type Breakpoint } from '../../shared'

import logoBmw from '../../../images/logo-bmw.svg'
import logoBmwWhite from '../../../images/logo-bmw-white.svg'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('bmw-branding')
export class BmwBranding extends TwLitElement {

    @property({ type: String }) 
    headline = "BMW Mustermann"

    @property({ type: String }) 
    subheadline = "Musterhausten"
    
    @consume({context: displayModeContext, subscribe: true}) 
    private _displayMode: string = "white"

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    private _isShowSmall() {
        return [ 'xs' ].includes( this._breakpoint?.name ?? '' )
    }

    render() 
    {
        const classes = this._isShowSmall()
            ? [ 'w-[34px] h-[34px]' ]
            : []

        return html`
            <a href="/" title="Zur Startseite" aria-label="Zur Startseite">
                <span class="flex gap-2 items-center pb-4">
                    ${
                        this._displayMode === "white" 
                        ? html`<img src=${logoBmw} alt="BMW Logo" class=${classes.join(' ')} />` 
                        : html`<img src=${logoBmwWhite} alt="BMW Logo" class=${classes.join(' ')} />` 
                    }
                    <span class="flex flex-col">
                        <span class="text-lg leading-none font-normal">${unsafeHTML(this.headline)}</span>
                        ${ this._isShowSmall() ? html`` : html`<div class="text-xs font-normal">${this.subheadline}</div>` }
                    </span>
                </span>
            </a>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'bmw-branding': BmwBranding
    }
}
